import React, { useMemo } from "react";

import { FormBuilder, Loader, Message, Modal } from "shared/components";
import { Spacer } from "shared/layout";
import { IAPIState, IFormSchema, IStatus } from "shared/types";
import { IAuthActions } from "Auth/types";
import { useStateActionMeta } from "Auth/utils";
import { makeSchema } from "./formData";

import { copy } from "shared/assets";
const { deleteAccount } = copy;

interface DeleteAccountProps {
  metaKey: IAuthActions;
  preventDeleteAccount?: boolean;
  preventDeleteMessage?: string | JSX.Element;
  isLoading?: boolean;
  handleDelete: (id?: string) => void;
  handleClose: () => void;
}

export const DeleteAccount: React.FC<DeleteAccountProps> = ({
  metaKey,
  preventDeleteAccount,
  preventDeleteMessage,
  isLoading,
  handleClose,
  handleDelete,
}) => {
  const meta = useStateActionMeta(metaKey);

  const schema: IFormSchema = useMemo(
    () => makeSchema("delete", handleClose),
    [handleClose]
  );

  const renderContent = () => {
    if (isLoading) return <Loader />;

    if (preventDeleteAccount) {
      return (
        <Message status={IStatus.error} hideBackground>
          <Spacer size="m">
            <p>{copy.deleteAccount.forbidden}</p>
            {preventDeleteMessage}
          </Spacer>
        </Message>
      );
    }

    return (
      <Spacer size="m">
        <Message
          message={deleteAccount.body}
          status={IStatus.warning}
          hideBackground
        />
        <FormBuilder
          {...schema}
          onSubmit={handleDelete}
          isSubmitting={meta?.status === IAPIState.pending}
          apiErrorMessage={
            meta?.error ? (meta?.message ? meta.message.body : true) : false
          }
          apiError={meta?.error}
        />
      </Spacer>
    );
  };

  return (
    <Modal data-testid="user_delete_modal" handleClose={handleClose}>
      {renderContent()}
    </Modal>
  );
};
